import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductCreateWfoodcostSelectProviderPage } from '../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider';
/**
 * Generated class for the ArticleViewProvidersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-providers',
    templateUrl: 'article-view-providers.html',
})
export class ArticleViewProvidersPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {
        this.navCtrl.push(ProductCreateWfoodcostSelectProviderPage, {
            update_state: true,
            product_uid: this.article.UID,
            products: this.article,
            product_name: this.globals.nameLangSelectProduct(this.article),
            product_measurement: this.article.measurement,
            product: this.article
        });
    }



}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-providers/article-view-providers.ts